import { QueryClient } from '@tanstack/react-query';

const defaultQueryConfig = { staleTime: 60000 };

export const queryClient = new QueryClient({
    defaultOptions: { queries: defaultQueryConfig }
});

export const getQueryKeyBase = (baseKey, ...args) => {
    if (!args) {
        return [baseKey];
    }
    return [baseKey, ...args];
};

export const QUERY_KEYS = {
    DASHBOARD_URL: 'dashboard_url'
};
